// Display only; keep original names and stable keys for matching and navigation.
export function topicDisplayName(value) {
  let name = String(value || '')
  let previous
  do {
    previous = name
    name = name.replace(/\([^()]*\)|（[^（）]*）/g, '')
  } while (name !== previous)
  return name.replace(/\s+/g, ' ').trim()
}
